// Lib
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import useUser from '../../../../hooks/useUser';
import useUI from '../../../../hooks/useUI';
import useAddToKits from '../../../../pages/Kits/hooks/useAddToKits';

// Utils
import isProductAvailable from '../../../../utils/isProductAvailable';
import getGridPropValues from '../../../../utils/getGridPropValues';

// Selectors
import { productsObjSelector } from '../../../../store/selectors';

// Styles
import { useStyles } from './OrderCardStyles';

const useOrderCard = ({ order, withChildren }) => {
  const productsObj = useSelector((state) => productsObjSelector(state));
  const { isKiteUser } = useUser();
  const { onAddToMyKits } = useAddToKits(order.id);
  const { isMobileMode, isTabletMode } = useUI();
  const { classes, cx } = useStyles({
    isMobileMode,
    isKiteUser,
    withChildren,
  });

  const gridPropValues = getGridPropValues(isTabletMode, isMobileMode);

  const canReorder = useMemo(
    () =>
      !!order?.order_items.find(({ product }) =>
        isProductAvailable(productsObj[product]),
      ),
    [order, productsObj],
  );

  return {
    productsObj,
    isKiteUser,
    onAddToMyKits,
    isMobileMode,
    isTabletMode,
    classes,
    cx,
    gridPropValues,
    canReorder,
  };
};

export default useOrderCard;
